import Cartao from './Cartao';

export const CategoriaCartao = Cartao;
